import { FetchState, hasValue } from "../Models/Client/FetchState"
import { useEffect, useMemo } from "react"
import {
    TemplateName,
    APIAppTemplateModel
} from "../Models/API/AppTemplateModel"
import { useAppInstance } from "./useAppInstance"
import { Result } from "../Models/Utility/Result"
import { useAppState } from "./useReduxState"
import { useDispatch } from "react-redux"
import { getTemplateByAppID } from "../Actions/API/AppTemplate/AppTemplateActions"

export function useAppTemplate(
    appID?: string,
    templateName?: TemplateName
): FetchState<APIAppTemplateModel> {
    const dispatch = useDispatch()
    // instanceFetch is necessary only when templateName isn't provided
    const instanceFetch = useAppInstance(
        templateName === undefined ? appID : undefined
    )
    const templateNameFetch = useMemo(
        () =>
            templateName !== undefined
                ? Result.ok(templateName)
                : hasValue(instanceFetch)
                ? instanceFetch.value.templateName === null ||
                  instanceFetch.value.templateName === undefined
                    ? Result.error<TemplateName>(
                          "This project isn't available any more"
                      )
                    : Result.ok(instanceFetch.value.templateName)
                : instanceFetch,
        [instanceFetch, templateName]
    )
    const templateFetch = useAppState(state =>
        hasValue(templateNameFetch)
            ? state.api.templates.records.get(templateNameFetch.value)
            : undefined
    )

    useEffect(() => {
        if (
            templateFetch !== undefined ||
            appID === undefined ||
            !hasValue(templateNameFetch)
        ) {
            return
        }

        dispatch(getTemplateByAppID(appID))
    }, [appID, dispatch, templateFetch, templateNameFetch])

    return hasValue(templateNameFetch) ? templateFetch : templateNameFetch
}
